(function () {
  'use strict';

  var root = document.documentElement;

  function setViewportHeight() {
    root.style.setProperty('--rd-vh', (window.innerHeight * 0.01) + 'px');
  }

  function setScrollState() {
    document.body.classList.toggle('rd-is-scrolled', window.scrollY > 8);
  }

  function markTouchDevice() {
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      document.body.classList.add('rd-touch-device');
    }
  }

  function protectFastClicks() {
    document.addEventListener('click', function (event) {
      var submitButton = event.target.closest('button[type="submit"], .add-to-cart, [data-rd-add-to-cart], [data-rd-atc]');
      if (!submitButton || submitButton.disabled) return;

      var form = submitButton.closest('form');
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;

      submitButton.classList.add('rd-clicked');
      window.setTimeout(function () {
        submitButton.classList.remove('rd-clicked');
      }, 1200);
    }, true);
  }

  function improveLazyImages() {
    var images = document.querySelectorAll('img');
    images.forEach(function (img, index) {
      if (!img.hasAttribute('loading') && index > 1) img.setAttribute('loading', 'lazy');
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  }

  function improveExternalLinks() {
    document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = (link.getAttribute('rel') || '').split(/\s+/);
      ['noopener', 'noreferrer'].forEach(function (value) {
        if (rel.indexOf(value) === -1) rel.push(value);
      });
      link.setAttribute('rel', rel.filter(Boolean).join(' '));
    });
  }

  function closeOpenDetailsOnEscape() {
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('details[open]').forEach(function (details) {
        details.removeAttribute('open');
      });
    });
  }

  function keepAnchorTargetsVisible() {
    if (!window.location.hash) return;
    var target = document.getElementById(window.location.hash.slice(1));
    if (!target) return;
    window.setTimeout(function () {
      target.scrollIntoView({ block: 'start' });
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', function () {
    setViewportHeight();
    setScrollState();
    markTouchDevice();
    protectFastClicks();
    improveLazyImages();
    improveExternalLinks();
    closeOpenDetailsOnEscape();
    keepAnchorTargetsVisible();
  });

  window.addEventListener('resize', setViewportHeight, { passive: true });
  window.addEventListener('orientationchange', setViewportHeight, { passive: true });
  window.addEventListener('scroll', setScrollState, { passive: true });
}());


/* Romeo Delauris UX hardening v13 */
(function () {
  'use strict';

  var lastModalTrigger = null;

  function updateProductOptionLabels(context) {
    (context || document).querySelectorAll('.product-options__swatch').forEach(function (group) {
      var checked = group.querySelector('.radio__input:checked + .radio__label');
      var label = group.querySelector('.js-swatch-label-name');
      if (checked && label && checked.dataset.variantName) {
        label.textContent = checked.dataset.variantName;
      }
    });
  }

  function improveSwatchAccessibility(context) {
    (context || document).querySelectorAll('.radio__option-swatch .radio__input').forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') {
        try {
          label = window.CSS && CSS.escape ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
        } catch (error) {
          label = null;
        }
      }
      var value = input.value || (label && label.dataset.variantName) || '';
      if (!value) return;
      input.setAttribute('aria-label', (input.dataset.option ? input.dataset.option + ': ' : '') + value);
      if (label && !label.getAttribute('title')) label.setAttribute('title', value);
    });
  }

  function hardenSocialModalA11y() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-rd-open]');
      if (opener) lastModalTrigger = opener;

      var dot = event.target.closest('[data-rd-gallery-dot]');
      if (dot) {
        var dots = dot.closest('[data-rd-gallery-dots]');
        if (dots) {
          dots.querySelectorAll('[data-rd-gallery-dot]').forEach(function (item) {
            item.setAttribute('aria-current', item === dot ? 'true' : 'false');
          });
        }
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var modal = document.querySelector('.rd-social-modal:not([hidden])');
      if (!modal) return;
      var focusables = modal.querySelectorAll('a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.querySelectorAll('.rd-social-modal').forEach(function (modal) {
      modal.querySelectorAll('[data-rd-gallery-dot]').forEach(function (dot) {
        dot.setAttribute('aria-current', dot.classList.contains('is-active') ? 'true' : 'false');
      });
    });

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'hidden') return;
        var modal = mutation.target;
        if (!modal.classList || !modal.classList.contains('rd-social-modal')) return;
        if (modal.hidden && lastModalTrigger && document.contains(lastModalTrigger)) {
          lastModalTrigger.focus({ preventScroll: true });
          lastModalTrigger = null;
        }
      });
    });

    document.querySelectorAll('.rd-social-modal').forEach(function (modal) {
      observer.observe(modal, { attributes: true });
    });
  }

  function preventDeadHashButtons() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[aria-disabled="true"][href="#"]');
      if (!link) return;
      event.preventDefault();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateProductOptionLabels(document);
    improveSwatchAccessibility(document);
    hardenSocialModalA11y();
    preventDeadHashButtons();
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.radio__input[data-option]')) return;
    var group = event.target.closest('.product-options__swatch');
    if (group) updateProductOptionLabels(group);
  });
}());
